/* eslint-disable import/extensions */
import configPackage from '../../package.json'

export const getAppVersion = () => configPackage.version
